<template>
  <v-container fill-height pa-0>
    <v-layout column>
      <v-toolbar color="primary flex justify">
        <router-link to="/login" class="pt-2">
          <img src="@/assets/citi.png" width="180">
        </router-link>
      </v-toolbar>
      <v-container fill-height class="justify">
        <v-form ref="form" class="flex" v-model="valid" @submit.prevent="login">
          <v-card class="elevation-3 px-2 py-4 ma-auto">
            <v-card-title class="justify">
              <div>
                <h3 class="headline mb-0 text-xs-center">PTSP Routing System</h3>
                <h4 class="text-xs-center font-weight-light">Log in to your account</h4>
              </div>
            </v-card-title>
            <v-card-text class="mt-4">
              <label>USER ID</label>
              <v-text-field
                class="font-14"
                solo
                name="username"
                label="Staff ID"
                type="number"
                required
                v-model="username"
                :rules="uidRules"
                :error="errors['username']"
                :errormessage="errors['username']"
              ></v-text-field>
              <label>PASSWORD</label>
              <v-text-field
                class="font-14"
                solo
                id="password"
                :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                :type="showPassword ? 'text' : 'password'"
                name="password"
                label="Password"
                v-model="password"
                :rules="passwordRules"
                hint="At least 6 characters"
                min="6"
                @click:append="showPassword = !showPassword"
              ></v-text-field>
            </v-card-text>
            <v-card-actions class="text-xs-center">
              <v-flex px-5 mb-4>
                <v-btn color="primary white--text ma-auto" type="submit" :disabled="!valid">Login</v-btn>
              </v-flex>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
import AuthLayout from "../../layouts/auth";
import { AUTH_LOGIN } from "@/store/actions/auth";

export default {
  name: "LoginPage",
  data() {
    return {
      showPassword: false,
      errors: [],
      username: "",
      uidRules: [
        v => !!v || "User Id is required"
        // v => /^\w+([\.-]?\w+)*@\w+(  [\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Invalid User ID'
      ],
      password: "",
      passwordRules: [
        v => !!v || "Password is required"
        // v => v.length >= 6 || 'Invalid Password'
      ],
      valid: true
    };
  },
  created() {
    this.$emit("update:layout", AuthLayout);
  },
  methods: {
    login() {
      const { username, password } = this;
      if (this.$refs.form.validate()) {
        this.$store.dispatch(AUTH_LOGIN, { username, password });
      }
    }
  }
};
</script>

<style>
.flex {
  display: flex;
}
.justify {
  justify-content: center;
}
.font-14 {
  font-size: 14px;
}
.font-12 {
  font-size: 12px;
}
</style>

